import projetosRotas from './projetos/ProjetosRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'
import paineisRotas from './paineis/PaineisRotas'
import etapasRotas from './etapas/EtapasRotas'

export default {
    path: 'gestores',
    name: 'Sgtec_Gestores',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        projetosRotas,
        ...etapasRotas,
        pagamentosRotas,
        paineisRotas
    ]
}
